import { render, staticRenderFns } from "./project-add.vue?vue&type=template&id=58eb6f02&scoped=true&"
import script from "./project-add.vue?vue&type=script&lang=js&"
export * from "./project-add.vue?vue&type=script&lang=js&"
import style0 from "./project-add.vue?vue&type=style&index=0&id=58eb6f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb6f02",
  null
  
)

export default component.exports